import { render, staticRenderFns } from "./CurriculumReadMenuNECItem.vue?vue&type=template&id=6aa2a58a&scoped=true&"
import script from "./CurriculumReadMenuNECItem.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadMenuNECItem.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumReadMenuNECItem.vue?vue&type=style&index=0&id=6aa2a58a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2a58a",
  null
  
)

export default component.exports